"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockPaymentError = exports.mockDigitalItems = exports.mockCapiV3ReturnSuccess = exports.mockInitiateConfigRequestSuccess = exports.mockOrderSuccess = exports.mockCapiV3OrderData = exports.mockCreditCardPayment = void 0;
var mockCreditCardPayment = {
  creditCard: '4111111111111111',
  securityCode: '123',
  expYear: '20',
  expMonth: '04',
  firstName: 'Brahmin',
  lastName: 'Dharmakirti',
  street1: 'Pratyaksa',
  street2: 'Anumana',
  city: 'Nalanda',
  state: 'IN',
  postalCode: '03359',
  phoneNumber: '600-660-0000',
  orderingURL: 'http://test.com/order',
  sessionID: 'mockSessionID',
  token: 'mockOrderingToken',
  blackboxUrl: 'mockIovationBlackbox',
  type: 'visa'
};
exports.mockCreditCardPayment = mockCreditCardPayment;
var mockCapiV3OrderData = {
  brand_code: 'TESTBRAND',
  amount: 25.93,
  recipient_full_name: 'Jane Recipient',
  sender_full_name: 'John Sender',
  faceplate_code: 'DBA3RG8CQ',
  uyo_image_url: '',
  uyo_video_url: '',
  street: '25 Pearl St.',
  street2: '',
  city: 'Portland',
  state: 'ME',
  zip_code: '04101',
  phone_number: '207-549-2200',
  recipient_email: 'dhouk@cashstar.com',
  currency_code: 'USD',
  promo_code: '',
  program_code: '',
  credit_card_bin: '411111',
  credit_card_last4: '',
  credit_card_number: '4111111111111111',
  credit_card_type: 'VISA',
  expiration: '2020-01-01T00:00:00',
  delivery_date: '2018-08-28T00:00:00',
  delivery_method: 'EMAIL',
  email_opt_in: 'F',
  security_code: '123',
  purchaser_first_name: 'John',
  purchaser_last_name: 'Sender',
  purchaser_email: 'holyhandgrenadeofantioch@cashstar.com'
};
exports.mockCapiV3OrderData = mockCapiV3OrderData;
var mockOrderSuccess = {
  purchaserEmail: 'holyhandgrenadeofantioch@cashstar.com',
  statement: 'MODPORT ECARDS',
  displayCreditCardNumber: 'XXXX-XXXX-XXXX-1111',
  recipientSms: '1234567890',
  recipientFullName: 'Jane Recipient',
  countryCode: 'US',
  recipientEmail: 'dhouk@cashstar.com',
  amount: '25.93',
  orderNumber: 'CNZXXXXXXX'
};
exports.mockOrderSuccess = mockOrderSuccess;
var mockInitiateConfigRequestSuccess = {
  checkoutId: 'test_checkoutId',
  merchantId: 'test_merchantId'
};
exports.mockInitiateConfigRequestSuccess = mockInitiateConfigRequestSuccess;
var mockCapiV3ReturnSuccess = {
  amount: '25.93',
  purchaser_email: 'holyhandgrenadeofantioch@cashstar.com',
  recipient_sms_number: '1234567890',
  Statement: 'MODPORT ECARDS',
  recipient_email: 'dhouk@cashstar.com',
  recipient_full_name: 'Jane Recipient',
  country_code: 'US',
  order_number: 'CNZXXXXXXX',
  display_credit_card_number: 'XXXX-XXXX-XXXX-1111'
}; // TODO: Clean these up, formalize the contract between a client app and order placement:
//  What attributes are needed for an item?

exports.mockCapiV3ReturnSuccess = mockCapiV3ReturnSuccess;
var mockDigitalItems = [{
  id: 'd6b94372-97f3-4b92-8367-81365c26bcce',
  isPlastic: false,
  deliveryMethod: 'EMAIL',
  faceplate: 'DBAVQMWNJ',
  senderName: 'Lando Calrissian',
  senderEmail: 'lando@cloudcity.org',
  recipientName: 'Han Solo',
  recipientEmail: 'hansolo@millenniumfalcon.io',
  recipientSms: '987 654 3210',
  hasPlasticNotification: false,
  // eslint-disable-next-line max-len
  message: 'Really sorry about my part in that whole freezing you in a block of carbonite thing, old buddy. Hope you can eventually get over it. Here\'s a giftcard for when you thaw out.',
  altText: 'Puppy frolicking',
  quantity: 1,
  denomination: 75,
  sendDate: 'Aug 12, 2017',
  sendTime: '5:15 PM',
  deliveryDate: '2017-08-12T21:15:00.000Z'
}, {
  id: '374aaf7c-e5f0-4f50-9c0c-765f91a8a2c3',
  isPlastic: false,
  deliveryMethod: 'EMAIL',
  faceplate: 'DD8NUFSXG',
  senderName: 'Lando Calrissian',
  senderEmail: 'lando@cloudcity.org',
  recipientName: 'Chewbacca',
  recipientEmail: 'chewie@millenniumfalcon.io',
  recipientSms: '321 456 7890',
  hasPlasticNotification: false,
  message: 'Please enjoy these giftcards - one for you, one for a friend! Just don\'t rip my arms off. Thanks.',
  altText: 'Cityscape',
  quantity: 2,
  denomination: 75,
  sendDate: 'Oct 13, 2018',
  sendTime: '8:15 AM',
  deliveryDate: '2018-10-13T12:15:00.000Z'
}, {
  id: 'fd3314f8-b87f-4d76-bfa4-ac7434edd37e',
  isPlastic: false,
  deliveryMethod: 'EMAIL',
  faceplate: 'DBT8H2B9M',
  senderName: 'Lando Calrissian',
  senderEmail: 'lando@cloudcity.org',
  recipientName: 'Lando Calrissian',
  recipientEmail: 'lando@cloudcity.org',
  recipientSms: '',
  hasPlasticNotification: false,
  message: 'A little something for myself. :)',
  altText: 'Grapefruit',
  quantity: 1,
  denomination: 100,
  sendDate: 'Jul 25, 2018',
  sendTime: '3:20 PM',
  deliveryDate: '2018-07-25T19:20:00.000Z',
  isRemoved: true
}];
exports.mockDigitalItems = mockDigitalItems;
var mockPaymentError = {
  status: 402,
  statusText: 'Payment Required',
  data: {
    error_code: 'PAYMENT_REQUIRED',
    error_message: 'We\'re sorry, broke da kine.'
  }
};
exports.mockPaymentError = mockPaymentError;